import { OnboardingState } from '../config/state.model';

/**
 * Read one cell value for a field from a row.
 * Returns null if the field wasn't mapped or the column isn't found.
 */
export function colVal(
  state: OnboardingState,
  fieldId: string,
  row: any[]
): string | null {
  const col = state.maps[fieldId];
  if (!col) return null;
  const idx = state.cols.indexOf(col);
  return idx >= 0 ? (String(row[idx] ?? '').trim() || null) : null;
}

/**
 * Build a payload object for one row containing EVERY field the user mapped.
 * Unmapped fields are included as null so the BE can handle them explicitly.
 */
export function buildRowPayload(
  state: OnboardingState,
  row: any[]
): Record<string, string | null> {
  const obj: Record<string, string | null> = {};
  for (const fieldId of Object.keys(state.maps)) {
    obj[fieldId] = colVal(state, fieldId, row);
  }
  return obj;
}
